import { render, staticRenderFns } from "./OAuth2.vue?vue&type=template&id=0bc0e08a"
import script from "./OAuth2.vue?vue&type=script&lang=js"
export * from "./OAuth2.vue?vue&type=script&lang=js"
import style0 from "./OAuth2.vue?vue&type=style&index=0&id=0bc0e08a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports